/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CheckoutBoxHeader from "../../CheckoutBoxHeader";
import CheckoutBranchesPopUp from "../../checkout-branches/CheckoutBranchesPopUp";
import { CheckoutIcons } from "../../../checkout-icons/GetCheckoutSvg";
import ReceivingTime from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/receiving-time/ReceivingTime";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import DisabledMethodMSg from "../../checkout-error-messages/DisabledMethodMSg";
import { useTranslation } from "@/hooks/localization/useTranslations";
import ReceivingAccordion from "./ReceivingAccordion";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { RecievingFields } from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/helpers";
import { useAtom } from "jotai";
import { disableSubmitBtnAtom } from "@/hooks/receivingHeaderAtom";

interface props {
  enabled: boolean;
  form: UseFormReturn<FieldValues, any>;
  isMobile: boolean;
  timeField: IField;
  pickup_not_available_message: string;
}
const PickupSection: React.FC<props> = ({
  enabled,
  isMobile,
  form,
  timeField,
  pickup_not_available_message,
}) => {
  const t = useTranslation();
  const [, setDisableSubmitBtn] = useAtom(disableSubmitBtnAtom);
  const [disableSelectTime, setDisableSelectTime] = useState(
    !form.watch(RecievingFields.branchFieldName),
  );
  useEffect(() => {
    setDisableSelectTime(!form.watch(RecievingFields.branchFieldName));
  }, [form.watch(RecievingFields.branchFieldName)]);
  useEffect(() => {
    form.unregister(RecievingFields.preferredBranchFieldName);
    setDisableSubmitBtn(false);
  }, [form.watch(RecievingFields.recievingFieldName)]);
  return enabled ? (
    <ReceivingAccordion
      accordionItems={[
        {
          accordionHeader: (
            <CheckoutBoxHeader
              svg={CheckoutIcons.pickup}
              title={t.pickup_address}
              mobile={isMobile}
              withoutBorder
            />
          ),
          accordionBody: (
            <CheckoutBranchesPopUp
              form={form}
              fieldName={RecievingFields.branchFieldName}
              mobile={isMobile}
            />
          ),
          disabled: false,
        },
        {
          accordionHeader: (
            <CheckoutBoxHeader
              svg={CheckoutIcons.popUpDeliveryTime}
              title={t.delivery_time}
              mobile={isMobile}
              withoutBorder
            />
          ),
          accordionBody: (
            <ReceivingTime
              timeField={timeField}
              form={form}
              timeTypeFieldName={RecievingFields.pickupTimeTypeFieldName}
            />
          ),
          disabled: disableSelectTime,
        },
      ]}
    />
  ) : (
    <DisabledMethodMSg message={pickup_not_available_message} />
  );
};

export default PickupSection;
